/**
 * Canonical business information — single source of truth for NAP, schema, and SEO.
 * Update here and every schema across the site picks it up.
 */
export const businessInfo = {
  name: "Floral Designs By Kim",
  legalName: "Floral Designs By Kim",
  url: "https://kimfloraldesigns.com",
  telephone: "+1-405-627-3557",
  telephoneDisplay: "(405) 627-3557",
  email: "lowkim24@yahoo.com",
  foundingDate: "1985",
  priceRange: "$$",
  description:
    "Custom wedding & event floral design in Cass City, Michigan. 40+ years of experience including former Disney floral designer. Serving Tuscola, Huron & Sanilac counties.",
  address: {
    "@type": "PostalAddress" as const,
    streetAddress: "7159 Elmwood Rd",
    addressLocality: "Cass City",
    addressRegion: "MI",
    postalCode: "48726",
    addressCountry: "US",
  },
  geo: {
    "@type": "GeoCoordinates" as const,
    latitude: 43.6011,
    longitude: -83.1747,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "09:00",
      closes: "17:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Saturday",
      opens: "09:00",
      closes: "14:00",
    },
  ],
  sameAs: [
    "https://www.facebook.com/FloralDesignsByKim",
    "https://www.instagram.com/floraldesignsbykim",
  ],
  image: "https://kimfloraldesigns.com/og-image.png",
  paymentAccepted: "Cash, Credit Card, Venmo, Zelle",
  currenciesAccepted: "USD",
} as const;

/** Full LocalBusiness JSON-LD — reusable on homepage, city pages, etc. */
export function getLocalBusinessSchema(overrides?: Record<string, unknown>) {
  return {
    "@context": "https://schema.org",
    "@type": "Florist",
    ...businessInfo,
    address: { ...businessInfo.address },
    geo: { ...businessInfo.geo },
    ...overrides,
  };
}

/** FAQPage JSON-LD from an array of {question, answer} */
export function getFAQPageSchema(faqs: { question: string; answer: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  };
}
